import type { ReactNode } from 'react';

interface AdditionalInformationSectionProps {
  className?: string;
  contentClassName?: string;
  label: string;
  children: ReactNode;
}

export default function AdditionalInformationSection({
  className = '',
  contentClassName = '',
  label,
  children,
}: AdditionalInformationSectionProps) {
  return (
    <div
      className={`flex flex-col justify-center items-center min-w-0 p-2 border border-pmw-separator-light dark:border-pmw-separator-dark rounded-[12px] ${className}`}
    >
      <span
        className={`inline-flex items-center max-w-full font-robotoMedium font-medium text-[12px] leading-[16px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark ${contentClassName}`}
      >
        {children}
      </span>
      <span className="font-robotoRegular font-normal text-[12px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
        {label}
      </span>
    </div>
  );
}
